import * as React from 'react';
import { IGeoRegion, IGeoTerritory } from '../../services/DataService';
import { useDataService } from '../../app/DataServiceContext';

export interface IGeoState {
    regions: IGeoRegion[];
    territories: IGeoTerritory[];
    loadingRegions: boolean;
    loadingTerritories: boolean;
    regionsError?: string;
}

/** Loads the region list once and territories whenever the region changes. */
export function useGeo(regionId: string): IGeoState {
    const dataService = useDataService();
    const [regions, setRegions] = React.useState<IGeoRegion[]>([]);
    const [territories, setTerritories] = React.useState<IGeoTerritory[]>([]);
    const [loadingRegions, setLoadingRegions] = React.useState(true);
    const [loadingTerritories, setLoadingTerritories] = React.useState(false);
    const [regionsError, setRegionsError] = React.useState<string>();

    React.useEffect(() => {
        let active = true;
        setLoadingRegions(true);
        dataService.getGeoRegions()
            .then((list) => { if (active) { setRegions(list); setRegionsError(undefined); } })
            .catch(() => { if (active) setRegionsError('Не удалось загрузить список регионов.'); })
            .finally(() => { if (active) setLoadingRegions(false); });
        return () => { active = false; };
    }, [dataService]);

    React.useEffect(() => {
        if (!regionId) {
            setTerritories([]);
            return;
        }
        let active = true;
        setLoadingTerritories(true);
        dataService.getTerritoriesByRegion(regionId)
            .then((list) => { if (active) setTerritories(list); })
            .catch(() => { if (active) setTerritories([]); })
            .finally(() => { if (active) setLoadingTerritories(false); });
        return () => { active = false; };
    }, [dataService, regionId]);

    return { regions, territories, loadingRegions, loadingTerritories, regionsError };
}
